var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "q-form",
      class: [
        _vm.labelPosition ? "q-form--label-" + _vm.labelPosition : "",
        { "q-form--inline": _vm.inline },
      ],
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }